import React, { useEffect, useState } from "react";
import styles from "./ThumbnailGrid.module.css";

// Renders a grid of thumbnails, given a user.
// If the user does not have thumbnails, or any of the thumbnails error,
// we'll refresh them on the backend.
function ThumbnailGrid({
  thumbnails,
  userId,
  batchId,
  refreshThumbnails,
  shortcodes,
}) {
  const [shouldRefresh, setShouldRefresh] = useState(false);
  console.log("shortcodes", JSON.stringify(shortcodes, null, 2));

  // Refresh thumbnails on load if they're missing
  useEffect(() => {
    if (!thumbnails || thumbnails.length === 0) {
      setShouldRefresh(true);
    }
  }, [thumbnails]);

  // If we get any error in our thumbnails, refresh them if we
  // havn't refreshed already.
  const onError = () => {
    if (!shouldRefresh) {
      setShouldRefresh(true);
    }
  };

  // Actually trigger the refresh
  useEffect(() => {
    if (shouldRefresh) {
      refreshThumbnails(userId, batchId);
    }
  }, [batchId, refreshThumbnails, shouldRefresh, userId]);

  const rows =
    thumbnails && thumbnails.length
      ? [thumbnails.slice(0, 6), thumbnails.slice(6, 12)]
      : [];

  if (!thumbnails || !thumbnails.length) {
    return "Loading";
  }

  // https://css-tricks.com/adaptive-photo-layout-with-flexbox/#all-hail-flexbox
  return rows.map((rowItems, i) => (
    <ul className={styles.wrapper} key={i}>
      {rowItems.map((thumb, index) => (
        <li key={shortcodes[index]} className={styles.item}>
          <img src={thumb} onError={onError} alt="" className={styles.image} />
        </li>
      ))}
    </ul>
  ));
}

export default ThumbnailGrid;
